import { owaSuiteHeaderRendered } from '../actions/owaSuiteHeaderRendered';
import { orchestrator } from 'satcheljs';
import { updateIsSuiteHeaderRendered } from 'owa-suite-header-store';

export const owaSuiteHeaderRenderedOrchestrator = orchestrator(owaSuiteHeaderRendered, () => {
    updateIsSuiteHeaderRendered(true);
});
